export default function initPasswordToggles(root = document) {
    const buttons = root.querySelectorAll("[data-password-toggle]");

    if (!buttons.length) {
        return;
    }

    buttons.forEach(function (button) {
        const targetSelector = button.getAttribute("data-password-target");
        const input = targetSelector ? root.querySelector(targetSelector) : null;

        if (!input) {
            return;
        }

        function syncState() {
            const isVisible = input.getAttribute("type") === "text";
            button.setAttribute("aria-pressed", isVisible ? "true" : "false");
            button.classList.toggle("is-active", isVisible);
            button.setAttribute("aria-label", isVisible ? "Ukryj hasło" : "Pokaż hasło");
        }

        button.addEventListener("click", function () {
            const isVisible = input.getAttribute("type") === "text";
            input.setAttribute("type", isVisible ? "password" : "text");
            syncState();
        });

        syncState();
    });
}
